import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function WeaponTypeRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {path: '/weapon-type', component: Index, isProtected: true, permissions: ['weapon_type_index']},
    {path: '/weapon-type/create', component: Create, isProtected: true, permissions: ['weapon_type_create']},
    {path: '/weapon-type/edit/:id', component: Edit, isProtected: true, permissions: ['weapon_type_edit']},

  ];

  return routes;
}
